import { useParams } from 'react-router-dom';
import {
  Form as ZolForm,
} from '@zolteam/zol-react-form';
// Services
import { useGetContentTypeQuery } from '../../../../services/cortizol/content-type/contentTypeQueries';
import { useGetContentQuery } from '../../../../services/cortizol/content/contentQueries';
// Hooks
import useLocale from '../../../../domain/cortizol/locale/useLocale';
import useContent from '../../../../domain/cortizol/content/useContent';
import useContentTranslation from '../../../../domain/cortizol/content-translation/useContentTranslation';
// Components
import Form from './Form';
import FormSkeleton from './FormSkeleton';
// Utils
import fr from '../../../../locales/fr.json';

/**
 * ContentTypeForm View
 * @returns {JSX.Element}
 */
function ContentTypeForm() {
  // Hooks
  const { contentTypeId, contentId } = useParams();
  const { currentLocale } = useLocale();
  const { getTranslationFromContent } = useContent();
  const { cleanDataFromAPI } = useContentTranslation();

  // Services
  const {
    data: dataContentType,
    isLoading: isLoadingContentType,
  } = useGetContentTypeQuery(contentTypeId);
  const {
    data: dataContent,
    isLoading: isContentLoading,
  } = useGetContentQuery(contentId);

  const defaultData = dataContent && currentLocale
    ? cleanDataFromAPI(getTranslationFromContent(dataContent, currentLocale)).data
    : undefined;

  return (isLoadingContentType || isContentLoading || !currentLocale)
    ? <FormSkeleton />
    : (
      <ZolForm
        name={dataContentType.schema.title}
        callbacks={{
          onSubmit: () => {},
        }}
        defaultValues={Object.keys(defaultData).length > 0 ? defaultData : undefined}
        schema={dataContentType.schema}
        translations={{
          formValidation: fr.cortizol.formValidation,
        }}
      >
        {(formConfig, formInfo) => (
          <Form
            formConfig={formConfig}
            formInfo={formInfo}
          />
        )}
      </ZolForm>
    );
}

export default ContentTypeForm;
